module.exports = __webpack_public_path__ + "media/images/parceiros_pagamentos/resized/visa-logo-dda79ead7543fc80b89b462b4586da71.svg";